module.exports = __webpack_public_path__ + "img/cabezote.25e61879.jpg";